module.exports = __webpack_public_path__ + "static/img/355.58b6dbdd.png";